import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import routes from '../routes/routes';
import { useAuth } from '../services/auth/AuthContext';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login, refreshWarning, clearWarning } = useAuth();

    // Hardcoded user credentials
    const validUser = { username: 'admin', password: 'password123' };

    useEffect(() => {
        // Clear the warning after 5 seconds
        if (refreshWarning) {
            const timer = setTimeout(() => {
                clearWarning();
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [refreshWarning, clearWarning]);

    const handleLogin = (e) => {
        e.preventDefault();

        if (username === validUser.username && password === validUser.password) {
            // Login the user
            login({ username });
            // Redirect to home page
            navigate(routes.home);
        } else {
            setError('Nom d\'utilisateur ou mot de passe incorrect');
        }
    };

    return (
        <div className="flex justify-center items-center h-screen bg-inputbackground">
            <div className="bg-white rounded-lg shadow-md p-10 w-full max-w-md text-center">
                <h1 className="text-3xl font-bold mb-2.5 text-blueprimary">MADATLAS</h1>
                <h2 className="text-xl mb-5 text-bluesecondary">Connexion</h2>

                {error && (
                    <div className="text-danger bg-danger bg-opacity-10 p-2 rounded mb-5">
                        {error}
                    </div>
                )}

                {refreshWarning && (
                    <div className="text-danger bg-danger bg-opacity-10 p-2 rounded mb-5">
                        Vous avez été déconnecté car vous avez actualisé la page. Veuillez vous reconnecter.
                    </div>
                )}

                <form onSubmit={handleLogin} className="text-left">
                    <div className="mb-5">
                        <label
                            htmlFor="username"
                            className="block mb-2 font-medium text-blueprimary"
                        >
                            Nom d'utilisateur
                        </label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            className="w-full p-2.5 border border-inputbackground rounded text-base focus:outline-none focus:border-greenprimary"
                        />
                    </div>

                    <div className="mb-5">
                        <label
                            htmlFor="password"
                            className="block mb-2 font-medium text-blueprimary"
                        >
                            Mot de passe
                        </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full p-2.5 border border-inputbackground rounded text-base focus:outline-none focus:border-greenprimary"
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full py-3 bg-greenprimary text-white border-none rounded text-base font-bold cursor-pointer transition-colors hover:bg-opacity-90"
                    >
                        Se Connecter
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;